import { useMemo } from 'react';
import { ADMIN_ROLE, OWNER_ROLE, ROLES_CAP } from '../utils/Constants';

/**
 * Hook para verificar si el usuario tiene permisos para gestionar referidos
 * Solo usuarios con roles Admin, Comité o Instrumentador tienen acceso
 */
export const useReferrerPermissions = () => {
  const hasPermission = useMemo(() => {
    const roles = localStorage.getItem('roles');
    
    if (!roles) {
      return false;
    }

    // Verificar si tiene rol de Admin o Owner
    const isAdmin = roles.includes(ADMIN_ROLE) || roles.includes(OWNER_ROLE);
    
    // Verificar si tiene rol de Comité
    const isComite = roles.includes(ROLES_CAP.comite);
    
    // Verificar si tiene rol de Instrumentador
    const isInstrumentator = roles.includes(ROLES_CAP.instrumentator);

    return isAdmin || isComite || isInstrumentator;
  }, []);

  return {
    hasPermission,
    canManageReferrers: hasPermission,
  };
};

